import React from 'react';

import { Body1, Body2 } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/common';
import { EBenefitProgram } from 'shared/repositories/mortgage-broker-calculator/entities/get_settings/ProgramsSummary';

type TDetailsBody = typeof Body1 | typeof Body2;

const getFamilyProgramDetails = (Body: TDetailsBody) => (
  <>
    <Body>Семьи, в которых:</Body>
    <ul>
      <li>
        <Body>{`есть ребёнок младше 7${NBSP}лет;`}</Body>
      </li>
      <li>
        <Body>или ребёнок с инвалидностью;</Body>
      </li>
      <li>
        <Body>
          {`или двое несовершеннолетних детей. В некоторых регионах и${NBSP}городах до 50${NBSP}000 жителей.`}
        </Body>
      </li>
    </ul>
  </>
);

const getItProgramDetails = (Body: TDetailsBody) => (
  <ul>
    <li>
      <Body>18–50 лет</Body>
    </li>
    <li>
      <Body>{`Работа в аккредитованной${NBSP}IT-компании (от 3${NBSP}месяцев)`}</Body>
    </li>
    <li>
      <Body>
        {`Доход от 90${NBSP}000${NBSP}₽. От 150${NBSP}000${NBSP}₽ — в${NBSP}городах‑миллионниках (кроме Москвы и${NBSP}СПб), Московской или${NBSP}Ленобласти`}
      </Body>
    </li>
    <li>
      <Body>{`Есть налоговые льготы (как${NBSP}IT‑специалист)`}</Body>
    </li>
  </ul>
);

const getDefaultProgramDetails = (Body: TDetailsBody) => (
  <Body>
    {`Кредит на${NBSP}недвижимость по${NBSP}рыночной ставке, который${NBSP}может${NBSP}взять любой гражданин РФ${NBSP}от${NBSP}18${NBSP}до${NBSP}75${NBSP}лет.`}
  </Body>
);

export const getProgramCardDetails = (
  benefitProgram: EBenefitProgram,
  isDesktop: boolean,
): React.ReactNode | undefined => {
  const Body = isDesktop ? Body1 : Body2;

  switch (benefitProgram) {
    case EBenefitProgram.Family:
      return getFamilyProgramDetails(Body);
    case EBenefitProgram.It:
      return getItProgramDetails(Body);
    case EBenefitProgram.NoProgram:
      return getDefaultProgramDetails(Body);
    default:
      return undefined;
  }
};
